import { importApplication } from "ee/actions/applicationActions";
import {
  UPLOADING_APPLICATION,
  createMessage,
} from "ee/constants/messages";
import { getIsImportingApplication } from "ee/selectors/applicationSelectors";
import type { SetProgress } from "design-system-old";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export interface UseMethodsProps {
  editorId?: string;
  workspaceId?: string;
  workspaceType?: string;
}

/**
 * This function is extended in EE so tread cautiously when modifying anything
 */
function useMethods({ editorId, workspaceId, workspaceType }: UseMethodsProps) {
  const dispatch = useDispatch();
  const [appFileToBeUploaded, setAppFileToBeUploaded] = useState<{
    file: File;
    setProgress: SetProgress;
  } | null>(null);
  const importingApplication = useSelector(getIsImportingApplication);
  const fileUploader = useCallback(
    async (file: File, setProgress: SetProgress) => {
      if (!!file) {
        dispatch(
          importApplication({
            appId: editorId,
            workspaceId: workspaceId || "",
            applicationFile: file,
            type: workspaceType || "",
          }),
        );
        setAppFileToBeUploaded({
          file,
          setProgress,
        });
      } else {
        setAppFileToBeUploaded(null);
      }
    },
    [],
  );

  const resetAppFileToBeUploaded = useCallback(() => {
    setAppFileToBeUploaded(null);
  }, [setAppFileToBeUploaded]);

  return {
    fileUploader,
    appFileToBeUploaded,
    resetAppFileToBeUploaded,
    uploadingText: createMessage(UPLOADING_APPLICATION),
    isImporting: importingApplication,
  };
}

export default useMethods;

